import React, { useState , useEffect} from "react";
import { Fragment } from "react";
import CommonLayout from "./CommonLayout";
import {Formik, Form, Field, ErrorMessage} from "formik";
import { Dialog, Transition, Popover } from "@headlessui/react";
import * as Yup from "yup";
import axios from "axios";
import { API_URL } from "api/config";
import { toast } from "react-toastify";

// Define Type for Blacklist Entry
interface BlacklistEntry {
  guestName: string;
  idType: string;
  idNumber: string;
  _id: string;
}
const Blacklist = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [blacklist, setBlackList] = useState<BlacklistEntry[]>([]);
  const [blacklistGuest, setBlacklistGuest] = useState<BlacklistEntry[]>([]);
  const [query, setQuery] = useState("");

  const token = localStorage.getItem("token");

    // Fetch Blacklist Data on Component Mount
    useEffect(() => {
      const fetchBlacklist = async () => {
        try {
          const response = await axios.get(`${API_URL}/owner/get-blacklist`, {
            headers: {
              token: token,
            },
          });
          if (response.data.error === false) {
            setBlackList(response.data.blacklistGuests || []);
            setBlacklistGuest(response.data.blacklistGuests || []);
            // Assuming 'blacklistEntries' is the array
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          toast.error("Failed to fetch blacklist data.");
        }
      };
  
      fetchBlacklist();
    }, [token]); 


  const validationSchema = Yup.object().shape({
    guestName: Yup.string().required("Guest name is required"),

    idType: Yup.string()
      .oneOf(["aadhaar", "pan"])
      .required("ID Type is required"),
    idNumber: Yup.string()
      .required("ID Number is required")
      .test("valid-id", "Invalid ID number", function (value) {
        const { idType } = this.parent; // Access the `idType` field from the parent object
        if (idType === "aadhaar") {
          return /^\d{12}$/.test(value); // Aadhaar validation
        } else if (idType === "pan") {
          return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value); // PAN validation
        }
        return true; // Return true if neither "aadhaar" nor "pan"
      }),
  });

  const handleSubmit = async (
    values: any,
    { resetForm }: { resetForm: () => void }
  ) => {
    resetForm();
    setIsPopoverOpen(false);
    try {
      const response = await axios.post(
        `${API_URL}/owner/blacklist`,
        {...values},
        {
          headers: {
            token: token,
          },
        }
      );
      if (response.data.error === false) {
        setBlackList((prev) => [...prev, response.data.blacklistEntry]);
        setBlacklistGuest((prev) => [...prev, response.data.blacklistEntry]);
       toast.success("Guest blacklisted successfully.");
      } else if (response.data.error === true) {
        toast.error(response.data.message); 
      }
    } catch (error) {
    }
  };
const handleSearch = (query: string) => {
    setQuery(query);

    if (!query.trim()) {
      setBlacklistGuest(blacklist); // reset to full list
      return;
    }

    const filteredGuest = blacklist.filter((guest) =>
      guest.idNumber.toLowerCase().includes(query.toLowerCase())
    );
    setBlacklistGuest(filteredGuest);
  };
  
  
    return (
    <div className="flex w-screen">
      <CommonLayout>
        <div
          className="nc-AccountPage flex flex-col  flex-grow w-full container"
          data-nc-id="AccountPage"
        >
          <div className="flex w-full justify-center">
            <div className="relative lg:w-[35%]">
              <input
                type="text"
                className="bg-white border rounded-xl w-full py-2 pr-10 pl-4"
                placeholder="Search for blacklisted guest"
                onChange={(e) => handleSearch(e.target.value)}
                value={query}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch(query);
                  }
                }}
              />
              {/* <button
                type="button"
                className="absolute right-2 top-1/2 transform -translate-y-1/2 h-8 w-8 flex items-center justify-center rounded-full focus:outline-none text-gray-500 hover:text-black"
                onClick={() => handleSearch(query)}             
              > 
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </button> */}
            </div>
            <button className="bg-custom-color text-white text-sm rounded-lg p-2 ml-2" onClick={() => setIsPopoverOpen(true)}>
              Add Blacklist
            </button>
            <Popover className="relative !z-max">
              {({ open }) => (
                <>
                  <Transition
                    as={Fragment}
                    show={isPopoverOpen}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-4"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 -translate-y-4"
                  >
                    <Popover.Panel className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-5 rounded-md shadow-lg w-96">
                    <h4 className="text-lg font-semibold mb-2">
                    Add Blacklist
                    </h4>
                      <Formik
                        enableReinitialize
                        initialValues={{
                          guestName: "",
                          idType: "aadhaar", // Default selection
                          idNumber: "", // Aadhaar or PAN value
                        }}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                      >
                        {({ isSubmitting, values, setFieldValue }) => (
                          <Form>
                            <div className="mt-4">
                              <Field
                                type="text"
                                name="guestName"
                                placeholder="Guest Name"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  setFieldValue("guestName", e.target.value);
                                }}
                              />
                              <ErrorMessage
                                name="guestName"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>

                            {/* <div className="mt-4">
                              <label className="block text-sm font-medium text-gray-700">
                                Select ID Type
                              </label>
                              <Field
                                as="select"
                                name="idType"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(
                                  e: React.ChangeEvent<HTMLSelectElement>
                                ) => {
                                  setFieldValue("idType", e.target.value);
                                  setFieldValue("idNumber", "");
                                }}
                              >
                                <option value="aadhaar">Aadhaar</option>
                                <option value="pan">PAN</option>
                              </Field>
                            </div> */}

                            <div className="mt-4">
                              <Field
                                type="text"
                                name="idNumber"
                                placeholder={"Enter Aadhaar Number"}
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  const { value } = e.target;
                                    const aadhaarValue = value
                                      .replace(/\D/g, "")
                                      .slice(0, 12);
                                  if (aadhaarValue) {
                                    setFieldValue("idNumber", aadhaarValue);
                                  } else {
                                    setFieldValue("idNumber", value);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="idNumber"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4 flex justify-end space-x-2">
                            <button
                              type="button"
                              onClick={() => setIsPopoverOpen(false)}
                              className="px-4 py-2 bg-gray-300 rounded-md"
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              disabled={isSubmitting}
                              className="px-4 py-2 bg-custom-color text-white rounded-md"
                            >
                              Submit
                            </button>
                          </div>
                          </Form>
                        )}
                      </Formik>
</div>
                      
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>
          </div>

          <div className="my-5 justify-center w-[50%] mx-auto">
          {blacklistGuest.length === 0 ? (
          <p>No blacklisted guests found.</p>
        ) : (
          blacklistGuest.map((guest: any, index) => (
            <div key={index} className="border rounded-lg p-2 mb-3 shadow-sm">
              <p className="capitalize text-sm ">{guest?.guestName}</p>
              <p className="text-sm text-neutral-700">{`AADHAAR : ${guest.idNumber}`}</p>
            </div>
          ))
        )}
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default Blacklist;
